import GlobalMagicOtp from "./GlobalMagicOtp";

export default GlobalMagicOtp;

